module.exports = __webpack_public_path__ + "img/devpo-phone.3a89e5ae.png";